module.exports = __webpack_public_path__ + "assets/icon_heartbeat.6b7af9f1.svg";